import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const Card = styled.div<{
  horizontalPaddings?: 'small' | 'medium' | 'big';
  verticalPaddings?: 'small' | 'medium' | 'big';
}>`
  background-color: ${({ theme }): string => theme.palette_white};
  border-color: ${({ theme }): string => theme.palette_gray_5};
  border-style: solid;
  border-width: 1px;
  border-radius: ${({ theme }): string => theme.border_radius_x1};
  box-sizing: border-box;

  ${({
    theme,
    verticalPaddings = 'medium'
  }): FlattenSimpleInterpolation | undefined => {
    if (verticalPaddings === 'small') {
      return css`
        padding-top: ${theme.spacing_unit_x1};
        padding-bottom: ${theme.spacing_unit_x1};
      `;
    }

    if (verticalPaddings === 'medium') {
      return css`
        padding-top: ${theme.spacing_unit_x2};
        padding-bottom: ${theme.spacing_unit_x2};
      `;
    }

    if (verticalPaddings === 'big') {
      return css`
        padding-top: ${theme.spacing_unit_x4};
        padding-bottom: ${theme.spacing_unit_x4};
      `;
    }

    return;
  }}

  ${({
    theme,
    horizontalPaddings = 'medium'
  }): FlattenSimpleInterpolation | undefined => {
    if (horizontalPaddings === 'small') {
      return css`
        padding-left: ${theme.spacing_unit_x1};
        padding-right: ${theme.spacing_unit_x1};
      `;
    }

    if (horizontalPaddings === 'medium') {
      return css`
        padding-left: ${theme.spacing_unit_x2};
        padding-right: ${theme.spacing_unit_x2};
      `;
    }

    if (horizontalPaddings === 'big') {
      return css`
        padding-left: ${theme.spacing_unit_x4};
        padding-right: ${theme.spacing_unit_x4};
      `;
    }

    return;
  }}
`;
